<template>
    <svg width="166" height="167" viewBox="0 0 166 167" fill="none" xmlns="http://www.w3.org/2000/svg">
        <ellipse opacity="0.1" cx="85.1336" cy="85.0892" rx="79.2" ry="79.68" fill="#9B9B9B" />
        <path
            d="M117.654 80.3045C118.983 80.3045 120.108 80.7675 121.029 81.6935C122.051 82.6195 122.563 83.7513 122.563 85.0888C122.563 86.4264 122.103 87.6096 121.182 88.6385C120.262 89.5645 119.086 90.0275 117.654 90.0275H89.888V117.807C89.888 119.248 89.4278 120.431 88.5073 121.357C87.5869 122.283 86.462 122.746 85.1325 122.746C83.803 122.746 82.678 122.283 81.7576 121.357C80.8372 120.328 80.377 119.145 80.377 117.807V90.0275H52.611C51.2816 90.0275 50.1055 89.5645 49.0828 88.6385C48.1624 87.6096 47.7021 86.4264 47.7021 85.0888C47.7021 83.7513 48.1624 82.6195 49.0828 81.6935C50.1055 80.7675 51.2816 80.3045 52.611 80.3045H80.377V52.5246C80.377 51.0842 80.8372 49.901 81.7576 48.975C82.678 47.9461 83.803 47.4316 85.1325 47.4316C86.462 47.4316 87.5869 47.9461 88.5073 48.975C89.4278 49.901 89.888 51.0842 89.888 52.5246V80.3045H117.654Z"
            fill="#B8CDD7" />
    </svg>

</template>

<script>
    export default {
  name: 'AddCampIcon',

    }
</script>

<style scoped lang="scss">
    svg {
        cursor: pointer;

        ellipse,
        path {
            transition: all 0.3s ease;
        }

        &:hover {
            ellipse,path {
                fill: #8DA0A9;
            }
        }

    }
</style>